import axios from 'axios'
import { API_ROOT } from '../services/api'

export const checkExit = (username) => {
  return axios({
    method: 'get',
    url: `${API_ROOT}/user/checkexit/${username}`,
  }).then((res) => {
    return res.data;
  }).catch((error) => {
    return error;
  })
}

export const checkExitPhoneAndName = (model) => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/checkexit`,
    data: model
  }).then((res) => {
    return res.data;
  }).catch((error) => {
    return error;
  })
}

export const register = (registerModel) => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/register`,
    data: registerModel
  }).then((res) => {
    return res;
  }).catch((error) => {
    return error;
  })
}

export const registerByAdministrator = (registerModel,token) => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/registerByAdministrator`,
    data: registerModel,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    }
  }).then((res) => {
    return res;
  }).catch((error) => {
    return error;
  })
}

export const forgotPassword = (forgotModel) => {
  console.log(forgotModel)
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/forgotpassword`,
    data: forgotModel
  }).then((res) => {
    return res;
  }).catch((error) => {
    return error;
  })
}

export const addEvaluation = (data, token) => {
  return axios({
      method: 'post',
      url: `${API_ROOT}/evaluation/create`,
      data: data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
  }).then((res) => {
      return res
  }).catch((error) => {
      return error
  })
}
